import { PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';

export const FlexiblePlanningNotAvailablePlaceholder = () => {
  return (
    <Centered>
      <PlaceholderSegment
        icon="info"
        info
        title="Flexible event planning is not available for this location"
        description="You can plan the exams in Plan Exams app"
      />
    </Centered>
  );
};
